export default {
    type: 'poster-board',
    name: 'Poster Board',
    osOnly: false,
    components: {
        root: {
            name: 'ModulePosterBoard',
            loader: () => import('./ModulePosterBoard')
        },
        form: {
            name: 'ModulePosterBoardForm',
            loader: () => import('./ModulePosterBoardForm')
        }
    }
};
